import { Box, Grid, Typography } from '@mui/material';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import leftDivider from '../../assets/left-divider.svg';
import rightDivider from '../../assets/right-divider.svg';
import baranLogo from '../../assets/baran_main_logo.svg';
import { getBreadcrumbs } from '../../utils/string';

import { t } from 'i18next';
import { useEffect } from 'react';

export default function Auth() {
	const navigate = useNavigate();
	const location = useLocation();

	const pathname = location.pathname;

	const breadCrumps = getBreadcrumbs(pathname);
	const pageName = breadCrumps[1];

	useEffect(() => {
		const isLogged = localStorage.getItem('token');
		if (isLogged) {
			navigate('/');
		}
	}, []);

	return (
		<Grid container className="h-screen">
			<Grid item xs={12} lg={6} className="flex flex-col items-center justify-center">
				<Box className="relative flex h-full flex-col justify-center rounded-lg p-5">
					<img src={baranLogo} className="mb-4 h-20 w-20 self-center" />
					<Box className="relative mb-12 flex items-center">
						<img src={rightDivider} className="py-7" />
						<Typography className="px-2 text-4xl font-medium text-grey-900">{pageName === 'register' ? t('sign_up') : t(pageName)}</Typography>
						<img src={leftDivider} />
					</Box>
					<Outlet />
				</Box>
			</Grid>
			<Grid item xs={0} lg={6} className="bg-auth-background bg-cover bg-right bg-no-repeat lg:left-0"></Grid>
		</Grid>
	);
}
